import { COMPANY_TYPE } from "@/screens/Companies/constants"
import { useCompanyStore, useCompanyTypesStore } from "@/screens/Companies/stores"
import { extractChildrenIds } from "@/screens/CompanySettings/Accounting/utils/common"

interface UseCompanyTypeFlagsReturn {
  isCompanyVendor: boolean
  isCompanyCustomer: boolean
}

export const useCompanyTypeFlags = (): UseCompanyTypeFlagsReturn => {
  const companyTypes = useCompanyTypesStore((state) => state.companyTypes)
  const company = useCompanyStore((state) => state.company)

  const [isCompanyVendor, isCompanyCustomer] = [COMPANY_TYPE.VENDOR, COMPANY_TYPE.CUSTOMER]
    .map((type) => extractChildrenIds(companyTypes, [type]))
    .map((ids) => ids.some((id) => company?.types?.includes(id)))

  return { isCompanyVendor, isCompanyCustomer }
}
